// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import PoolOrderExchanges from './poolOrderExchanges';
import React from 'react';

function PoolOrderExchangesPage () {

    return (
        <AuthenticatedPage className="atp-page atp-pool-order-exchanges-page">
            <PoolOrderExchanges />
        </AuthenticatedPage>
    );

}
PoolOrderExchangesPage.displayNAme = 'PoolOrderExchangesPage';

export default PoolOrderExchangesPage;
